import Validatable from '@/validator/Validatable';

export interface IHeaderBidderSettingsStepAPI {
  rules: {
    ssps: number[];
    deals: string[];
    buyers: string[];
    advertisers: string[];
  };
  local_auction_strategy: 'highest_cpm';
}

export interface IHeaderBidderSettingsStep {
  ssps: number[];
  deals: string[];
  buyers: string[];
  advertisers: string[];
  localAuctionStrategy: 'highest_cpm';
}

export class HeaderBidderSettingsStep extends Validatable implements IHeaderBidderSettingsStep {
  constructor(
    public ssps: number[],
    public deals: string[],
    public buyers: string[],
    public advertisers: string[],
    public localAuctionStrategy: 'highest_cpm' = 'highest_cpm',
  ) {
    super();
  }

  static fromApi(step: IHeaderBidderSettingsStepAPI): HeaderBidderSettingsStep {
    return new HeaderBidderSettingsStep(
      step.rules.ssps,
      step.rules.deals,
      step.rules.buyers,
      step.rules.advertisers,
      step.local_auction_strategy,
    );
  }

  public toApi(): IHeaderBidderSettingsStepAPI {
    return {
      rules: {
        ssps: this.ssps,
        deals: this.deals,
        buyers: this.buyers,
        advertisers: this.advertisers,
      },
      local_auction_strategy: this.localAuctionStrategy,
    };
  }

  public copy(): HeaderBidderSettingsStep {
    return new HeaderBidderSettingsStep(
      [...this.ssps],
      [...this.deals],
      [...this.buyers],
      [...this.advertisers],
      this.localAuctionStrategy,
    );
  }

  static validatorCreateRules() {
    return {
      ssps: 'not_empty',
      deals: 'not_empty',
      buyers: 'not_empty',
      advertisers: 'not_empty',
    };
  }

  static parse(step: IHeaderBidderSettingsStep): HeaderBidderSettingsStep {
    return new HeaderBidderSettingsStep(
      step.ssps || [],
      step.deals || [],
      step.buyers || [],
      step.advertisers || [],
      'highest_cpm',
    );
  }
}
